import { useContext, useEffect, useState } from 'react';
import LegoAdminPageContext from '../../legoAdminPageContext';
import _ from 'lodash';
import SpecSourceBadge from '../components/SpecSourceBadge';
import LegoContextSummary from '../../../components/lego/LegoContextSummary';
import { IconButton } from '../../../components/common/IconButton';
import ModelContextEditor from '../../../components/lego/ModelContextEditor';
import MultiValueSelector from '../../../components/common/editors/MultiValueSelector';
import useAsyncEffect from '../../../components/common/react-hooks/useAsyncEffect';
import { createFilter } from 'react-select';
import { getFlexibleRegex } from '../../../components/common/editors/autocomplete-filter-logic';


const filterFunc = createFilter();

export default function SpecsGroupCompactInput({ context = null, value, onChange }) {
  const { page } = useContext(LegoAdminPageContext);

  const [contextSearch, setContextSearch] = useState(context);
  const [contextOptions, setContextOptions] = useState([]);
  const [valueOptions, setValueOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useAsyncEffect(async () => {
    if (contextSearch?.modelId) {
      setLoading(true);
      let filter = { 'context.modelId': contextSearch.modelId };
      console.log('filter', filter);
      let options = await page.service('services/cerokm/specsgroup').find({ query: { ...filter } });
      setContextOptions(options);
      setLoading(false);
    } else {
      setContextOptions([]);
    }
  }, [contextSearch]);

  useAsyncEffect(async () => {
    let byId = _.keyBy(options.concat(valueOptions), '_id');
    let covered = _.filter(value, id => byId[id]);
    let uncovered = _.difference(value, covered);
    if (uncovered.length > 0) {
      let newOptions = await page.service('services/cerokm/specsgroup').find({ query: { _id: { $in: uncovered } } });
      
      if(!contextSearch && newOptions[0]?.context?.modelId) {
        setContextSearch({ modelId: newOptions[0].context.modelId });
      }

      setValueOptions([...valueOptions, ...newOptions]);
    }
  }, [JSON.stringify(value)]);

  let options = _.sortBy(_.uniqBy(contextOptions.concat(valueOptions), '_id'),
   d => d.context.modelId,
   d => d.context.ver,
   d => d.context.trim,
   d => d.type === 'trim' ? 1 : 2,
   d => d.name);

  let groupedByBasedOn = _.groupBy(options, 'basedOn');

  let noGroup = _.sortBy(options.filter(o => !o.basedOn), 'name');

  let modelIdYear = _.groupBy(noGroup, o => JSON.stringify(_.omit(o.context, 'trim')));

  let selectOptions = _.map(options || [], o => {
    let { name, context, basedOn, type } = o;    
    return ({
      label: <span className={`inline-block ${type === 'trim' ? 'bg-light-warn p-1' : 'pl-2'}`}>
        <LegoContextSummary inline context={_.omit(context, 'trim')} />
        <span className={'badge badge-dark'}>{context.trim || ''}</span> 
        <span className={'ml-1 small'}>{name}</span>
        <span className={'ml-1 badge badge-secondary'}>{type}</span>
      </span>,
      value: o,
    });
  });

  const filterOption= (option, search) => {
    let o = option.data.value;
    if(!o?.context) {
      return false;
    }
    let regex = getFlexibleRegex(search);
    let text = `${o.context.modelId} ${o.context.ver || ''} ${o.context.trim || ''} ${o.name} ${o._id} ${o.type}`
    let match = text.match(regex);
    // console.log('filter', search, JSON.stringify(o), match);
    return match;
  }

  return <div className={`mt-1 overflow-visible`}>
    <div className={'zoom-75 d-flex align-items-center'}>
      Showing (in autocomplete) trims for:&nbsp;<ModelContextEditor className={'flex-grow-1'} value={contextSearch} onChange={setContextSearch} />
    </div>

    <MultiValueSelector getOptionValue={o => o.value._id} value={value} onChange={onChange} filterOption={filterOption} options={selectOptions} />
  </div>
}
